export const SETTINGS_STORAGE_KEY = 'SETTINGS';

export interface Settings {
  numberOfFirstDigitsOfDeviceId: number;
  preserveValues: boolean;
}
